import { useContext, useEffect, useState } from 'react';
import { getCustomisationFieldData, getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
// import './CustomModule.scss';
import { changeNumericalFieldValue, changeStringFieldValue, changeValue_noType } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import { ShowColorPicker } from '../../../../../../forms/ColorPicker/ColorPickerPopUp';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";

import ImageIcon from '../../../../WorkspaceAssets/ListIcons/image-icon.png';
import { COLOUR_NAME_TO_COLOUR_HEX } from '../../../../../../../helpers/Colours';
// import Toggle from './toggleSwitch/Toggle';
import RangeSlider from './slider/RangeSlider';
import { WORKING_ON_NODE_DATA } from '../../../EditablePreview/VisualisedComponents/VisualisedNode';

const RangeSliderField = (props) => {
    const fieldData = props.fieldData;
    const moduleConfig = props.moduleConfig;
    const groupConfig = props.groupConfig;
    const customisationVars = props.customisationVars;

    // const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    /* let optionsData = [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
    ]; */
    /* if (fieldData?.customFieldConfig?.dataLink) {
        optionsData = getCustomisationFieldData(campaignContext.campaignData, props.selectedFeatureNode.path, fieldData.customFieldConfig.dataLink);
    } */
    /* const findDisplayValue = (value) => {
        console.log("Boolean dropdown: Finding display value for:", value, optionsData, typeof value);
        const option = optionsData?.find(opt => (opt.value === value || opt.val === value));
        console.log("Boolean dropdown: Found option:", option);
        return option ? option.label : value;
    } */

    const [currentValue, setCurrentValue] = useState(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    useEffect(() => {
        setCurrentValue(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);

    const changeFieldValue = (fieldId, value) => {
        WORKING_ON_NODE_DATA.fieldData = fieldData;
        WORKING_ON_NODE_DATA.node = props.selectedFeatureNode;
        if (changeNumericalFieldValue(customisationVars, fieldData?.customFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
            setCurrentValue(value);
            props?.forceUpdateComponent?.();
        }
    }

    const customisationSchema = getCustomisationFieldData(props.campaignData, props.selectedFeatureNode.path, fieldData.customFieldConfig.dataLink);
    // console.log("RangeSliderField: customisationSchema:", customisationSchema, props);

    return (
        <>
            <div className={`v2-module-field-label${!props.isEnabled ? ' disabled' : ''}`}>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Choose'}</div>
            {/* <ModuleTextInput
                value={findDisplayValue(currentValue)}
                fieldId={'toggle-drop-down'}
                enabled={true}
                editable={false}
                onChange={changeFieldValue}
                hiddenDropDown={true}
                hiddenDropDownOptions={optionsData || []}
                dropDownValue={currentValue}
            /> */}
            {/* <Toggle
                value={currentValue}
                onToggle={() => changeFieldValue(fieldData?.customFieldConfig?.fieldId, !currentValue)}
            /> */}
            <div className={`v2-field-holder${!props.isEnabled ? ' v2-module-disabled-field' : ''}`}>
                <RangeSlider
                    min={customisationSchema?.minVal ?? 0}
                    max={customisationSchema?.maxVal ?? 100}
                    value={currentValue}
                    onChange={props.isEnabled ? (e) => changeFieldValue(fieldData?.customFieldConfig?.fieldId, e.target.value) : null}
                    showValue={props.showValue ?? false}
                />
            </div>
        </>
    );
};

export default RangeSliderField;
